import React, { useState } from 'react';
import axios from 'axios';
import './fitness.css';
import InputField from '../../components/TextInput/InputField';
import Footer from '../../components/footer/Footer';

const FitnessForm = () => {
  const [formData, setFormData] = useState({
    height: "",
    weight: "",
    age: "",
    sex: "",
    hypertension: "",
    diabetes: "",
    fitnessGoal: "",
  });

  const [recommendation, setRecommendation] = useState(""); 
  const [error, setError] = useState(null); 

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      
      if (name === "height" || name === "weight") {
        const heightInMeters = parseFloat(updatedData.height) / 100 || 0;
        const weightInKg = parseFloat(updatedData.weight) || 0;

        if (heightInMeters > 0) {
          const bmi = (weightInKg / (heightInMeters * heightInMeters)).toFixed(2);
          updatedData.bmi = bmi;
        }
      }

      return updatedData;
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); 
    try {
      // Send POST request to Flask API
      const response = await axios.post('http://127.0.0.1:5000/predict', formData);
  
      // Check the response and set the recommendation
      if (response.data.fitnessGoal) {
        setRecommendation(response.data.fitnessGoal);
      } else {
        setError("No recommendation found.");
      }
    } catch (err) {
      
      setError("Error fetching recommendation. Please try again.");
      console.error(err); 
    }
  };
  

  return (
    <>
     
    <div className='marginLR'>
    <div className="container forms-container">
        <h2 className="text-center  mb-4">
          Fill out the form to get your Fitness Goal Recommendation!
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <InputField
              label="Height (cm)"
              name="height"
              placeholder="Enter your Height in cm"
              value={formData.height}
              onChange={handleChange}
              required
              className="col-md-6 mb-3"
            />
            <InputField
              label="Weight (kg)"
              name="weight"
              placeholder="Enter your Weight"
              value={formData.weight}
              onChange={handleChange}
              required
              className="col-md-6 mb-3"
            />
          </div>
          <div className="row">
          <InputField
                label="BMI"
                id="bmi"
                name="bmi"
                placeholder="BMI (auto-calculated)"
                value={formData.bmi}
                readOnly
                className="col-md-6 mb-3"
              />

            <InputField
              label="Age"
              name="age"
              placeholder="Enter your Age"
              value={formData.age}
              onChange={handleChange}
              required
              className="col-md-6 mb-3"
            />
            
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Hypertension</label>
              <select
                className="form-select"
                name="hypertension"
                value={formData.hypertension}
                onChange={handleChange}
                style={{
                  color: formData.timeSlot ? "black" : "black", 
                  
                  fontStyle:'italic'
                }}
                required
              >
                <option value="">Do you have Hypertension?</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Diabetes</label>
              <select
                className="form-select"
                name="diabetes"
                value={formData.diabetes}
                onChange={handleChange}
                style={{
                  color: formData.timeSlot ? "black" : "black", 
                  
                  fontStyle:'italic'
                }}
                required
              >
                <option value="">Do you have Diabetes?</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Sex</label>
              <select
                className="form-select"
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                style={{
                  color: formData.timeSlot ? "black" : "black", 
                 
                  fontStyle:'italic'
                }}
                required
              >
                <option value="">Select Gender</option>
                <option value="0">Male</option>
                <option value="1">Female</option>
              </select>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Fitness Goal</label>
            <textarea
              className="form-control gym-form-control"
              name="fitnessGoal"
              placeholder="What do you aim to achieve? (e.g., Lose weight, Build muscle)"
              value={formData.fitnessGoal}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Submit
          </button>
        </form>

        {/* Display the recommendation or error */}
        {recommendation && (
          <div className="mt-4 alert alert-success">
            <h4>Recommended Fitness Goal:</h4>
            <p>{recommendation}</p>
          </div>
        )}
        {error && (
          <div className="mt-4 alert alert-danger">
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
     
    </>
  );
};

export default FitnessForm;
